<template>
  <v-card :loading="loading" class="mx-auto my-12" max-width="474" min-height="550">
    <v-img height="250" :src="image03"></v-img>

    <v-card-title
      >Sobre o
      <span style="font-family: 'Fontdiner Swanky', serif;"
        >VIOLENT NOISE</span
      ></v-card-title
    >

    <v-card-text>
      <!--
      <v-row align="center" class="mx-0">
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">4.5 (413)</div>
      </v-row>

      <div class="my-4 subtitle-1 black--text">
        + • <span style="font-family: 'Fontdiner Swanky', serif;">VIOLENT NOISE</span>, Projeto, Descrição
      </div>
-->

      <div>
        O
        <span style="font-family: 'Fontdiner Swanky', serif;"
          >VIOLENT NOISE</span
        >
        foi idealizado e criado por Pierre Cortes. Paulistano, apreciador do
        Rock, Metal e suas subdivisões desde o início dos anos 80, o objetivo de
        criar o projeto foi justamente a necessidade de difundir, fortalecer e
        compartilhar o cenário Underground e as bandas que dele fazem parte.
        Stay Rock!
      </div>
    </v-card-text>

<!--
    <v-divider class="mx-4"></v-divider>

    <v-card-title>Entre em contato</v-card-title>

    <v-card-text>
      <v-chip-group
        v-model="selection"
        active-class="deep-purple accent-4 white--text"
        column
      >
        <v-chip>pierre@violentnoise.com.br</v-chip>

        <v-chip>twitter: @pierre</v-chip>

        <v-chip>messenger: pierre.cortez@hotmail.com</v-chip>

        <v-chip>whatsapp: (11) 834838-884989</v-chip>
      </v-chip-group>
    </v-card-text>
-->    
    <!--
    <v-card-actions>
      <v-btn color="deep-purple accent-4" text @click="reserve">
        Envie um email
      </v-btn>
    </v-card-actions>
-->
  </v-card>
</template>

<script>
const image3 = require("@/assets/images/content/music.jpg");

export default {
  data: () => ({
    image03: image3,
    loading: false,
    selection: 0
  })
};
</script>

<style></style>
